import { render, staticRenderFns } from "./OVwithOTData.vue?vue&type=template&id=2df24a86&lang=pug"
import script from "./OVwithOTData.vue?vue&type=script&lang=js"
export * from "./OVwithOTData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports